import React, { useRef } from "react";
import ReactPlayer from "react-player";

const Preview = (props) => {
  let previewPlayer = useRef();

  return (
    <>
      <ReactPlayer
        ref={previewPlayer}
        width="100%"
        height="100%"
        url="https://server.royalskannada.com/hls/royalskannada.m3u8"
        controls={true}
        playing={true}
        muted={false}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
        }}
      />
    </>

  );
};

export default Preview;